module.exports = __webpack_public_path__ + "static/img/组 (6).f2c6330.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2019_firefly_TerWeb/5/组 (6).jpg
// module id = Gpwb
// module chunks = 1